import { Component } from '@angular/core';

@Component({
  selector: 'app-consulta',
  standalone: true,
  imports: [],
  template: `
    <div>
      <p>O Diário Oficial de Minas Gerais é uma fonte confiável de informações públicas, sendo o principal veículo de publicação oficial do Estado de Minas Gerais desde 21 de abril de 1892. Com a transição para o formato eletrônico o jornal se tornou ainda mais acessível, permitindo que qualquer pessoa, de qualquer lugar, consulte conteúdos publicados, de forma simples, prática e gratuita.</p>
      <p>Seja para acompanhar atos governamentais, buscar informações jurídicas ou realizar pesquisas específicas, como nomes de servidores, escolas ou órgãos públicos, o Diário Oficial oferece ferramentas que tornam esse processo simples e eficiente.</p>
      <p>Quer saber como funciona o serviço de consulta ao acervo do Diário Oficial de Minas Gerais? Continue lendo e descubra tudo o que você precisa saber!</p>
    </div>
  `
})
export class ConsultaComponent {

}
